import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { fetcher } from "../helpers/global";
import { useAppContext } from "../hooks/useAppContext";
import useToast from "../hooks/useToast";
import { getCartToken } from "../services/cart.service";
import "./SearchBar.scss";

function SearchBar({
  searchCatOptions,
  setSearchCatOptions,
  fundCategoryId,
  setFundCategoryId,
}) {
  const { register, handleSubmit, setValue } = useForm();
  const [loading, setLoading] = useState(true);
  const {
    setSearch,
    search,
    fundCategoryId: originalFundCategoryId,
  } = useAppContext();
  let navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const urlSearch = location.search;
    const searchKeywordString = new URLSearchParams(urlSearch).get("q");
    setValue("search", searchKeywordString);
    setSearch(searchKeywordString);
  }, [location.search]);

  const onSubmit = (data) => {
    const cat = searchCatOptions[data["search-category-ids"]];
    const searchParams = new URLSearchParams();

    if (data.search) {
      searchParams.append("q", data.search);
    } else {
      searchParams.delete("q");
    }

    setValue("search", data.search);
    setSearch(data.search);

    if (cat) {
      setFundCategoryId(cat?.attributes.drupal_internal__tid);
    } else {
      setFundCategoryId(originalFundCategoryId);
    }

    navigate({
      pathname: cat?.attributes.path.alias || "/give",
      search: searchParams.toString(),
    });
  };

  const notifyFetchFundCategoriesError = useToast({
    type: "error",
    id: "fundCategories",
    actionText: "RETRY?",
    action: async () => await fetchFundCategories(),
    dismissable: true,
    message: "There was a problem loading options for Where to Give.",
  });

  function fetchFundCategories() {
    const cartToken = getCartToken();
    const url = "jsonapi/fund-categories";
    const headers = {
      "content-type": "application/vnd.api+json",
    };
    return fetcher("GET", url, null, headers)
      .then((response) => {
        const { data } = response;
        setLoading(true);
        setSearchCatOptions(data);

        let selectValue = null;
        data.filter((v, k) => {
          if (v.attributes.drupal_internal__tid === parseInt(fundCategoryId)) {
            selectValue = k;
          }
        });
        setValue("search-category-ids", selectValue);
        setLoading(false);
        return true;
      })
      .catch(() => {
        notifyFetchFundCategoriesError();
      });
  }

  React.useEffect(() => {
    fetchFundCategories();
  }, [fundCategoryId]);

  return (
    <div className="search-bar">
      <form className="search-bar__form" onSubmit={handleSubmit(onSubmit)}>
        <div className="search-bar__element">
          <label htmlFor="search-bar__input">Find a Fund</label>
          <input
            className="search-bar__input"
            id={"search-bar__input"}
            {...register("search")}
            placeholder="Search" />
        </div>
        <div className="search-bar__element search-bar__element--separator">
          &nbsp;
        </div>
        <div className="search-bar__element">
          <label htmlFor="search-bar__filter">Where to Give</label>
          <select
            className={`search-bar__filter fade${
              loading ? " transparent" : ""
            }`}
            id="search-bar__filter"
            {...register("search-category-ids")}>
            <option value="">Areas of Need</option>
            {searchCatOptions.map((term, k) => {
              return (
                <option
                  key={term.id}
                  value={k}
                  dangerouslySetInnerHTML={{ __html: term.attributes.name }}
                />
              );
            })}
          </select>
        </div>
        <button className="search-bar__submit" type="submit">
          <span className="visually-hidden">Search</span>
        </button>
      </form>
    </div>
  );
}

export default SearchBar;
